<template>
  <div class="d-flex flex-wrap sm-gap" style="max-width: 400px;">
    <a target="_blank" :href="base_url + 'Export_CSV/export_inscrits.php?type=gmcap&id=' + mainStore.module.id"><v-btn
        color="primary-dark" variant="outlined" density="compact">GMCAP</v-btn></a>
    <a target="_blank" :href="base_url + 'Export_CSV/export_inscrits.php?type=speaker&id=' + mainStore.module.id"><v-btn
        color="primary-dark" variant="outlined" density="compact">Animateur</v-btn></a>
    <a target="_blank"
      :href="base_url + 'Export_CSV/export_inscrits.php?type=finances&id=' + mainStore.module.id"><v-btn
        color="primary-dark" variant="outlined" density="compact">Finances</v-btn></a>
    <a target="_blank" :href="base_url + 'Export_CSV/export_inscrits.php?type=complet&id=' + mainStore.module.id"><v-btn
        color="primary-dark" variant="outlined" density="compact">Complet</v-btn></a>
    <a target="_blank"
      :href="base_url + 'Export_CSV/export_inscrits.php?type=preinscriptions&id=' + mainStore.module.id"
      v-if="mainStore.module.has_preinscription || mainStore.module.some_races_have_preinscription || mainStore.module.preinscription_ended"><v-btn
        color="primary-dark" variant="outlined" density="compact">Préinscriptions</v-btn></a>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
export default {
  data() {
    return {
      base_url: process.env.VUE_APP_API_BASE,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss" scoped></style>